(() => {
  if (customElements.get("four-up-images")) {
    return;
  }

  class FourUpImages extends HTMLElement {
    constructor() {
      super();
      this.desktopMatchQuery = window.matchMedia("(min-width: 990px)");
      this.selectors = {
        slider: "[data-slider]",
        pagination: "[data-pagination]",
      };
      this.sliderElement = this.querySelector(this.selectors.slider);
      this.slider = null;
      this.options = {
        slidesPerView: 1,
        pagination: {
          el: this.querySelector(this.selectors.pagination),
          type: "bullets",
          clickable: true,
        },
        spaceBetween: 16,
        breakpoints: {
          750: {
            slidesPerView: 2,
          },
        },
      };
    }

    connectedCallback() {
      this.setHandlers();
      this.initSlider();
    }

    initSlider() {
      if (!this.sliderElement) return;
      if (this.desktopMatchQuery.matches) {
        if (this.slider.destroyed) return;
        return this.destroy();
      }
      if (!!this.querySelector(".swiper-initialized")) return;
      this.slider = new Swiper(this.sliderElement, this.options);
    }

    destroy() {
      typeof this.slider.destroy === "function" &&
        this.slider.destroy(true, true);
    }

    setHandlers() {
      ["load", "resize", "shopify:section:load"].forEach((eventName) => {
        window.addEventListener(
          eventName,
          this.debounce((event) => {
            this.initSlider();
          }, 300).bind(this)
        );
      });
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  customElements.define("four-up-images", FourUpImages);
})();
